import { defineStore } from 'pinia';

export const useSidebarStore = defineStore('sidebar', {
  state: () => ({
    active: true,
  }),
  actions: {
    toggleSidebar() {
      this.active = !this.active;
    },
    openSidebar() {
      this.active = true;
    },
    closeSidebar() {
      this.active = false;
    },
  },
  persist: true,
});
